import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Close order',
      title: 'Close order',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Order successfully closed',
    }
  }
}